import React from 'react'
import { Link } from 'react-router-dom'
import AuthLayout from '../../custom/components/templates/AuthLayout'
import './Registration.css'
import Layout from '@/custom/components/templates/Layout'

const RegisterSuccess = () => {
    return (
        <Layout>
            {' '}
            <div className="register-success text-center mt-4">
                <img src="/assets/images/favicon.png" />
                <h4 className="reg-success-head">Thank you for registering with us!</h4>
                <p className="reg-success-note">
                    You are ready to start making offers. For assistance, please view the short{' '}
                    <Link to="/my-account#tutorialSec" className="tutorialLink">
                        tutorial
                    </Link>{' '}
                    videos on your account page. Click below to begin exploring listings.
                    {/* Thanks for Registering as a Bidder! Ready to start bidding? Good luck! If you
                    need assistance, we&#39;re here. Happy Bidding! */}
                </p>
                <div className="mt-4">
                    <Link to="/" className="reg-trans-btn">
                        Start Exploring Now
                    </Link>
                </div>
            </div>
        </Layout>
    )
}

export default RegisterSuccess
